/**
 * Created by JasonChou on 17/6/14.
 */
import React, {Component} from 'react'
import {gridHelper2}from '../../utils/uiUtils';
export default class Grid extends Component {
    render() {
        return (<div {...this.props} className="grid-column"/>)
    }
}
Grid.gridHelper = gridHelper2;


// WEBPACK FOOTER //
// ./src/components/layouts/GridColumn.js